import { render, staticRenderFns } from "./NewCheck.vue?vue&type=template&id=2aca4024&scoped=true&"
import script from "./NewCheck.vue?vue&type=script&lang=js&"
export * from "./NewCheck.vue?vue&type=script&lang=js&"
import style0 from "./NewCheck.vue?vue&type=style&index=0&id=2aca4024&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aca4024",
  null
  
)

export default component.exports